import { Building2, LineChart, MoreHorizontal, Users } from '@tamagui/lucide-icons';
import { TabBarButton } from '@unistocks/components/tab-bar-button/tab-bar-button';
import { t } from '@unistocks/localization';
import { quicker, quickest } from '@unistocks/shared/animations';
import { useTabBarStyle } from '@unistocks/shared/hooks/use-tab-bar-style';
import { Tabs } from 'expo-router';
import { SceneStyleInterpolators } from 'expo-router/build/react-navigation/bottom-tabs';

export default function AdminTabLayout() {
  const tabBarStyle = useTabBarStyle();

  return (
    <Tabs
      screenOptions={{
        lazy: true,
        freezeOnBlur: true,
        sceneStyle: { backgroundColor: 'transparent' },
        tabBarAllowFontScaling: false,
        tabBarHideOnKeyboard: true,
        tabBarShowLabel: false,
        tabBarVisibilityAnimationConfig: {
          show: { animation: 'spring', config: quickest },
          hide: { animation: 'spring', config: quickest }
        },
        tabBarStyle,
        headerShown: false,
        animation: 'shift',
        sceneStyleInterpolator: SceneStyleInterpolators.forShift,
        transitionSpec: {
          animation: 'spring',
          config: quicker
        }
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: t('::Menu:Dashboard'),
          href: null
        }}
      />

      <Tabs.Screen
        name="tenant-management"
        options={{
          title: t('AbpTenantManagement::Menu:TenantManagement'),
          tabBarButton: props => (
            <TabBarButton
              Icon={Building2}
              label={t('AbpTenantManagement::Menu:TenantManagement')}
              {...props}
            />
          )
        }}
      />

      <Tabs.Screen
        name="user-management"
        options={{
          title: t('AbpIdentity::Users'),
          tabBarButton: props => (
            <TabBarButton Icon={Users} label={t('AbpIdentity::Users')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="asset-management"
        options={{
          title: t('::Menu:Assets'),
          tabBarButton: props => (
            <TabBarButton Icon={LineChart} label={t('::Menu:Assets')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="(menu)"
        options={{
          title: t('::Menu:More'),
          tabBarButton: props => (
            <TabBarButton Icon={MoreHorizontal} label={t('::Menu:More')} {...props} />
          )
        }}
      />

      <Tabs.Screen
        name="role-management"
        options={{
          title: t('AbpIdentity::Users'),
          href: null
        }}
      />

      <Tabs.Screen
        name="setting-management"
        options={{
          title: t('AbpSettingManagement::Settings'),
          href: null
        }}
      />
    </Tabs>
  );
}
